/// <reference path="../../typings/jquery/jquery.d.ts" />
/// <reference path="../../typings/jquery/jquery.extensions.d.ts" />
var TotalJobsGroup;
(function (TotalJobsGroup) {
    var Header;
    (function (Header) {
        var Search = (function () {
            function Search($, location, headerAnalytics) {
                if ($ == null) {
                    throw new Error("'$' was not specified.");
                }
                this.$ = $;
                if (this.$.isNullOrUndefined(location)) {
                    throw new Error("'location' was not specified.");
                }
                if (this.$.isNullOrUndefined(headerAnalytics)) {
                    throw new Error("'headerAnalytics' was not specified.");
                }
                this.location = location;
                this.headerAnalytics = headerAnalytics;
            }
            Search.prototype.getRedirectUrl = function ($parentElement) {
                var $ = this.$;
                var queryString = {
                    s: "header"
                };
                var searchParams = {
                    Keywords: $(".search-keywords", $parentElement).val(),
                    LTxt: $(".search-location-text", $parentElement).val()
                };
                var locationsearchtype = $(".search-locationsearchtype", $parentElement).val();
                if (typeof locationsearchtype !== 'undefined') {
                    if (locationsearchtype.toString().lastIndexOf("CTD_", 0) === 0) {
                        searchParams['duration'] = $(".search-locationsearchtype", $parentElement).val().toString().replace("CTD_", "");
                    }
                    else {
                        searchParams['radius'] = $(".search-locationsearchtype", $parentElement).val().toString();
                    }
                    ;
                }
                $.each(searchParams, function (index, value) {
                    if (!$.isNullOrUndefined(value) && value.length > 0) {
                        var extension = {};
                        extension[index] = value;
                        $.extend(queryString, extension);
                    }
                });
                var resultsUrl = "/onsitesearch?";
                return resultsUrl + $.param(queryString);
            };
            // As the CMS app already contains a <form>(coz webforms), we have to use Javascript for the search bar searching.
            Search.prototype.redirectToResultsPage = function ($searchBar) {
                var url = this.getRedirectUrl($searchBar);
                this.location.href = url;
            };
            Search.prototype.performSearch = function ($target) {
                var $searchBar = $target.closest(".navbar-search-container");
                this.redirectToResultsPage($searchBar);
            };
            Search.prototype.initialize = function ($container) {
                var self = this;
                var $ = this.$;
                // ReSharper disable SuspiciousThisUsage
                $(".search-submit-button", $container).on("click", function ($event) {
                    self.performSearch($($event.target));
                });
                // Enter key has a different behaviour for dropdowns, so radius field is omitted.
                $(".search-keywords,.search-location-text", $container).on("keydown", function ($event) {
                    if ($event.which === 13) {
                        self.performSearch($($event.target));
                    }
                });
                // ReSharper restore SuspiciousThisUsage
            };
            return Search;
        }());
        Header.Search = Search;
    })(Header = TotalJobsGroup.Header || (TotalJobsGroup.Header = {}));
})(TotalJobsGroup || (TotalJobsGroup = {}));

//# sourceMappingURL=header-search.js.map
